///in the DOM wrapped images must come before the text that is wrapped
// around them. In mobile, however, it is desired that images be placed
// in the order that they are written in the .txt doc. For wrapped images
// this will be after the text. The previous text, however, can be broken
// up into multiple <p> tags. This code finds each wrapped image and then
// traverses back through the DOM until it reaches a non <p> element then
// sticks the image before the last <p> element. 


var { isExtraSmall, isSmall, isMedium, isLarge } = require("./lib/breakpoints");
var debounce = require("./lib/debounce");

window.addEventListener("resize", debounce(moveWrappedImages));


function moveWrappedImages(){
    const wrapped_images = document.getElementsByClassName('wrap');

    if(!isExtraSmall.matches){
        for(const image of wrapped_images){
            var child_nodes = image.parentNode.childNodes,
                first_child = image.parentNode.firstElementChild,
                length = child_nodes.length,
                element = image.previousElementSibling;     

            if(element){ //on resize the image is already in place and often doesn't have any previous siblings
                for(var i=0; i<length; i++){
                    if(element.nodeName != "P" || element == first_child){
                        break;
                    }else{
                        element = element.previousElementSibling;
                    }
                }
                if(element.nodeName == "P"){ //in the case that there's only one <p> before the image
                    image.parentNode.insertBefore(image, element);
                }else{
                    image.parentNode.insertBefore(image,element.nextElementSibling);
                }
            }
        }
    }
}

moveWrappedImages();

